import React, { ReactNode } from 'react'
import { Transition, Dialog } from '@headlessui/react'

type DialogModalProps = {
  onClose: () => void
  isOpen: boolean
  children: ReactNode
  modalParentClassName?: string
  dialogPanelClassName?: string
}

const DialogModal = (props: DialogModalProps) => {
  const {
    isOpen,
    onClose,
    children,
    modalParentClassName,
    dialogPanelClassName,
  } = props

  return (
    <Transition.Root show={isOpen} as={React.Fragment} appear>
      <Dialog as="div" className="relative z-[1000]" onClose={onClose}>
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-25 transition-opacity" />
        </Transition.Child>
        <div
          className={`fixed inset-0 z-10 overflow-y-auto p-4 sm:p-6 md:p-20 ${
            modalParentClassName || ''
          } flex justify-center items-center`}
        >
          <Transition.Child
            as={React.Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel
              className={`mx-auto transform overflow-hidden shadow-2xl ring-1 ring-black ring-opacity-5 transition-all bg-white ${dialogPanelClassName}`}
            >
              {children}
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

export default DialogModal
